import { Wording } from '@/types';

export const COOKING_WORDING_CZ: Wording = {
  components_header_media_content: 'Videa o vaření',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recepty',
  components_header_text2: 'Blog',
  components_header_members: 'Členové',
  hero_text: 'Vařte s vášní, jezte s radostí',
  hero_button_text: 'Začněte vařit ještě dnes',
  components_ressources_section_title: 'ZDROJE',
  components_ressources_subheader_text: 'Všechny zdroje, které potřebujete k učení, vaření a tvorbě lepšího jídla',
  components_ressources_span_text: 'Objevte bohatou sbírku videoreceptů, podrobných kuchařských průvodců a odborných postřehů o párování chutí, prezentaci jídel a kulinářské kreativitě.',
  components_ressources_card_1_title: 'Inspirace pro vaření',
  components_ressources_card_1_text: 'Nechte se inspirovat kreativními recepty a kuchařskými videi.',
  components_ressources_card_2_title: 'Znalosti vaření',
  components_ressources_card_2_text: 'Naučte se základní techniky vaření, kombinace chutí a základy párování jídel prostřednictvím srozumitelných a praktických průvodců.',
  components_ressources_link: 'Sledujte videa',
  components_notes_and_google_title_1: 'Vaření',
  components_notes_and_google_title_2: 'Každodenní vaření',
  components_notes_and_google_title_3: 'Konzistentní kuchařské dovednosti',
  components_review_google_text: 'Recenze na Googlu',
  media_content_section_title: 'Videa o vaření',
  media_content_section_subheader_text: 'Prozkoumejte recepty a podrobná videa s návody k vaření.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Další videa',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Průvodci a články',
  text2_section_button_more: 'Další články',
  components_text1_section_title: 'RECEPTY',
  components_text1_subheader_text: 'Lahodné recepty pro každodenní vaření',
  components_text1_span_text: 'Objevte snadno srozumitelné recepty určené pro každodenní přípravu jídel, s jasnými kroky a skvělými výsledky.',
  components_text1_card_1_title: 'Začněte svůj den správně',
  components_text1_card_1_text: 'Jednoduché a chutné recepty pro lahodný a chutný začátek dne.',
  components_text1_card_3_title: 'Nápady na chutný oběd',
  components_text1_card_3_text: 'Lahodné recepty na obědy, které se snadno připravují a jsou plné chuti.',
  components_text1_card_2_title: 'Recepty na uklidňující večeři',
  components_text1_card_2_text: 'Teplé a syté recepty na večeři, ideální pro pohodové večery doma.',
  components_text1_link: 'Zobrazit všechny recepty',
  components_footer_text: 'Naučte se lépe vařit, tvořte lepší jídlo: Vaše kuchyně, vaše cesta.',
  components_footer_info: 'Informace',
  components_footer_registration_number: 'Evidenční číslo',
  components_footer_legal: 'Právní',
  components_footer_terms: 'Obchodní podmínky',
  components_footer_privacy: 'Zásady ochrany osobních údajů',
  button_load_more: 'Načíst více',
  page_media_1_content_hero_text: 'Objevte jednoduchá kuchařská videa pro každý vkus',
  page_text1_hero_text: 'Recepty',
  page_text1_section_title: 'Tipy na vaření',
  page_text1_subheader_text: 'Recepty',
  page_text2_hero_text: 'Náš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Průvodci a články',
  enter_email_title: 'Pro pokračování zadejte prosím svůj e-mail',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Zadejte',
  components_login_success_text: 'Přihlášení úspěšné!',
  components_card_link_media_content: 'Sledujte nyní',
  components_card_link_text1_content: 'Zobrazit recept',
  components_card_link_text2_content: 'Zobrazit článek',
};